import React from "react";

import { Container } from "react-bootstrap";
import DsnGrid from "../components/DsnGrid";

import FantasyMap from "../components/fantasy/FantasyMap";
import Footer from "../components/footer/Footer";
import InfoBox from "../components/contact/InfoBox";
import ContactForm from "../components/contact/ContactForm";
import { Helmet } from "react-helmet";

function World() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Fantasy Map | Mystirien</title>
        <meta property="og:title" content="Fantasy Map | Mystirien" />
        <meta
          property="og:description"
          content="Explore the interactive fantasy world of Mystirien, a Celtic-inspired universe brought to life through music and art."
        />
        <meta property="og:url" content="https://mystirien.com/map" />
        <meta
          property="og:image"
          content="https://mystirien.com/assets/img/mystirien-og.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <FantasyMap />

      {/*Start Contact Form && Info Box*/}
      <Container className="section-margin">
        <DsnGrid col={2} colTablet={1}>
          <InfoBox className="background-section p-30" />
          <ContactForm />
        </DsnGrid>
      </Container>

      <Footer />
    </React.Fragment>
  );
}

export default World;
